import  React from 'react'

export interface Props {
    label: string
    preview?: boolean
}

export const TabHeading = (props: Props) => {
  const { preview, label } = props
  if (preview) {
    return (
      <div className="form-tab-heading-preview mt-4">
        {label}
      </div>
    )
  }
  return (
    <h2>{label}</h2>
  )
}
